import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dfa0ff24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circle" }

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'

type Emits = {
  (event: 'scroll-to-bottom'): void
}

type Props = {
  showScrollButton: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollToBottom',
  props: {
    showScrollButton: { type: Boolean }
  },
  emits: ["scroll-to-bottom"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scroll-button-container", _ctx.showScrollButton ? '' : 'hide'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SvgIcon, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('scroll-to-bottom'))),
        height: "24",
        width: "24",
        color: "var(--neutral-20)",
        name: "arrow-down-lg"
      })
    ])
  ], 2 /* CLASS */))
}
}

})